import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWrongSize = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g opacity={0.6}>
      <mask
        id="a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill="#D9D9D9" d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#DE5930"
          d="M11 5.1V4q0-.424.288-.712A.97.97 0 0 1 12 3q.426 0 .713.288Q13 3.575 13 4v1.05q.75.15 1.413.538.662.387 1.162.962.276.35.238.763a.96.96 0 0 1-.388.687 1.05 1.05 0 0 1-.762.238.96.96 0 0 1-.688-.388 2.474 2.474 0 0 0-1.925-.9q-.274 0-.537.075t-.513.2a1 1 0 0 1-.787.025.99.99 0 0 1-.563-.55 1 1 0 0 1-.025-.788.99.99 0 0 1 .55-.562q.2-.1.413-.15T11 5.1m8.1 16.8L15.2 18q-.374.375-1.025.613A4.8 4.8 0 0 1 13 18.9V20q0 .424-.287.712A.97.97 0 0 1 12 21a.97.97 0 0 1-.712-.288A.97.97 0 0 1 11 20v-1.15a5.15 5.15 0 0 1-1.925-.913A4.8 4.8 0 0 1 7.75 16.35a1.1 1.1 0 0 1-.075-.825.98.98 0 0 1 .525-.625q.426-.2.838-.05t.637.55q.375.7 1.013 1.15T12.2 17q.45 0 .825-.113.375-.112.725-.337L2.1 4.9a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.426 0 .7.275l17 17a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275"
        />
      </g>
    </g>
  </svg>
);
export default SvgWrongSize;
